import React, {useCallback} from 'react';
import {useHeaderDrawerDispatch, useHeaderDrawerState} from './header-drawer.context';
import {IoMdClose} from 'react-icons/io';
import {Drawer} from 'presentation/common/components/style-guide/drawer';
import {
  BackIcon, BeneficiaryIcon,
  InscriptionsIcon,
  LogoutIcon,
  MenuIcon,
  SignIcon,
  UserLightIcon,
  FrequentQuestionIcon
} from 'presentation/common/components/style-guide/icons';

import clsx from "clsx";
import {Link, NavLink, useHistory} from "react-router-dom";
import {ScrollLink} from "presentation/common";
import {AppRoutes} from "application/index";
import {useSignDocuments} from "application/use-sign-documents";

import LogoImg from 'assets/images/logo.png';
import styles from './mobile-drawer.module.scss';

const NotAuthenticatedActions = React.memo(({useInsideScroll, onToggle}) => {
  return useInsideScroll
    ? <>
      <li onClick={onToggle}>
        <BeneficiaryIcon/>
        <ScrollLink className="mr-3" to="benefit-section"> Beneficios </ScrollLink>
      </li>
      <li onClick={onToggle}>
        <FrequentQuestionIcon/>
        <ScrollLink to="question-section"> Preguntas Frecuentes </ScrollLink>
      </li>
      <li onClick={onToggle}>
        <Link className="mr-3" to={AppRoutes.signIn}> <UserLightIcon/> Iniciar Sesión </Link>
      </li>
    </>
    : <>
      <li onClick={onToggle}>
        <BeneficiaryIcon/>
        <Link className="mr-3" to="/"> Beneficios </Link>
      </li>
      <li onClick={onToggle}>
        <FrequentQuestionIcon/>
        <Link className="mr-3" to="/"> Preguntas Frecuentes </Link>
      </li>
      <li onClick={onToggle}>
        <Link className="mr-3" to={AppRoutes.signIn}> <UserLightIcon/> Iniciar Sesión </Link>
      </li>
    </>
});

export const MobileDrawer = (props) => {
  const {
    isAuthenticated,
    userInfo,
    onSignOut,
    useInsideScroll,
    enabledBackBehavior
  } = props;

  const history = useHistory();
  const {docs = []} = useSignDocuments();
  const dispatch = useHeaderDrawerDispatch();
  const {isOpen} = useHeaderDrawerState();

  const toggleFn = useCallback(() => {
    dispatch({
      type: 'TOGGLE',
    });
  }, []);

  const onToggle = useCallback(() => {
    if (enabledBackBehavior) {
      history.goBack();
      return;
    }

    toggleFn();
  }, []);

  const signOut = useCallback(() => {
    onSignOut?.();
    toggleFn();
  }, []);

  return (
    <Drawer
      width="320px"
      drawerHandler={
        <div className={styles.handler}>
          {enabledBackBehavior ? <BackIcon/> : <MenuIcon/>}
        </div>
      }
      open={isOpen}
      toggleHandler={onToggle}
      closeButton={<IoMdClose size="24px" color="#000000"/>}
      drawerClassName={styles.drawer}
      closeButtonContainerClassName={styles.closeButton}>
      <div className={styles.content}>
        <img src={LogoImg} alt="logo" onClick={() => history.replace(AppRoutes.home)}/>
        {
          isAuthenticated &&
          <>
            <div className="pt-4 text-center flex flex-col items-center">
              <p>{userInfo?.fullName}</p>
              <p>{userInfo?.profile?.rut || '-'}</p>
            </div>
            <ul className={styles.menuContainer}>
              <li onClick={onToggle}>
                <NavLink
                  activeStyle={{color: "var(--primary)"}}
                  to={AppRoutes.myDocs} exact>
                  <InscriptionsIcon/>
                  MIS INSCRIPCIONES
                </NavLink>
              </li>

              <li onClick={onToggle}>
                <SignIcon/>
                <NavLink
                  exact
                  activeStyle={{color: "var(--primary)"}}
                  to={AppRoutes.signDocuments}>POR FIRMAR</NavLink>
                {
                  docs?.length > 0 &&
                  <span className={styles.badge}>{docs.length}</span>
                }
              </li>

              <li onClick={onToggle}>
                <NavLink
                  activeStyle={{color: "var(--primary)"}}
                  to={AppRoutes.myProfile} exact>
                  <UserLightIcon/>
                  MI PERFIL
                </NavLink>
              </li>

              <li onClick={signOut}>
                <LogoutIcon/> <span>CERRAR SESIÓN</span>
              </li>
            </ul>
          </>
        }

        {
          !isAuthenticated &&
          <ul className={clsx(styles.menuContainer, styles.signOut)}>
            <NotAuthenticatedActions useInsideScroll={useInsideScroll} onToggle={onToggle}/>
          </ul>
        }
      </div>
    </Drawer>
  );
};

export default MobileDrawer;
